import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { firebaseConfig } from '../../common/constants'
import { increment } from '../../features/resultSlice'
import ReactDOM from 'react-dom'
import { scanResultQueue } from '../../scanResultQueue'
import {
  deleteTransaction,
  updateTransaction,
} from '../../services/transactions'
import BatchNumberFinder from '../BatchNumberFinder'
import useStyles from './styles'

import { IoCheckmarkDoneSharp } from 'react-icons/io5'
import { padding } from '@mui/system'

const { getAuth, signInAnonymously } = require('firebase/auth')

const { initializeApp } = require('firebase/app')
const { getDatabase, ref, onValue, remove } = require('firebase/database')

const getPlatformFromAlgorithm = (algoRaw) => {
  const algo = (algoRaw || '').trim().toLowerCase()
  if (algo === 'fzfba') return 'Auto-fallback'
  if (algo === 'fzfbm' || algo === 'fbm') return 'Manual-Fallback'
  if (algo === 'bt') return 'Auto'
  if (algo === 'manual') return 'Manual'
  if (algo === '') return 'Manual'
  return 'Auto'
}

const ScanResult = ({ closeModal }) => {
  const classes = useStyles()
  const firebase = initializeApp(firebaseConfig)
  const [currentItem, setCurrentItem] = useState(null)
  const dispatch = useDispatch()
  const auth = getAuth()

  signInAnonymously(auth)
    .then(() => { })
    .catch((error) => { })

  const listenFirebaseEvents = async () => {
    const database = ref(getDatabase(firebase), sessionStorage['username'])
  onValue(database, (snapshot) => {
    const results = snapshot.child('/').val()
    if (results) {
      const isOnCurrentScansRoute = window.location.hash === '#/current-scans'
      for (const key of Object.keys(results)) {
        const array = results[key]
        if (array.length === 1 && array[0]['algo'] === 'bt') {
          deleteFirebaseEntry(key)
        } else if (array.length > 1) {
          if (!isOnCurrentScansRoute) {
            continue
          }
          showSelectScanPopup(array).then(async (selectedItem) => {
              if (selectedItem) {
                selectedItem['firebaseKey'] = key
                selectedItem['algo'] = array[0]['algo'] || ''
                selectedItem['platform'] = array[0]['platform'] || ''
                const result = await processSelectedItemDirectly(selectedItem)
                if (result === true) {
                  await deleteFirebaseEntry(key)
                  dispatch(increment())
                  scanResultQueue.clearProcessingQueue()
                }
              } else {
                await deleteFirebaseEntry(key)
              }
            })
          } else {
            array[0]['firebaseKey'] = key
            scanResultQueue.addItem(array[0], key)
            dispatch(increment())
            getNextItem()
          }
        }
        dispatch(increment())
        getNextItem()
      }
    })
  }

  useEffect(() => {
    listenFirebaseEvents()
    getNextItem()
  }, [])

  const [type, setType] = useState('')
  const [partyCode, setPartyCode] = useState('')
  const [partyName, setPartyName] = useState('')
  const [imageUrl, setImageUrl] = useState('')
  const [productName, setProductName] = useState('')
  const [productCode, setProductCode] = useState('')
  const [batch, setBatch] = useState('')
  const [mBatch, setMBatch] = useState('')
  const [mrp, setMRP] = useState('')
  const [expiryDate, setExpiryDate] = useState('')
  const [mfgDate, setMFGDate] = useState('')
  const [quantities, setQuantities] = useState('1')
  const [productId, setProductId] = useState('')
  const [transactionId, setTransactionId] = useState('')
  const [firebaseKey, setFirebaseKey] = useState('')
  const [sessionId, setSessionId] = useState('')
  const [category, setCategory] = useState('')
  const [remark, setRemark] = useState('')
  const [lrDate, setLrDate] = useState('')
  const [lrNo, setlrNo] = useState('')
  const [claimNo, setclaimNo] = useState('')
  const [claimDate, setclaimDate] = useState('')
  const [receivedDate, setReceivedDate] = useState('')
  const [inputParams, setInputParams] = useState('')
  const [algorithmType, setAlgorithmType] = useState('')
  const [receivedPlatform, setReceivedPlatform] = useState('')

  const sanitizeValue = (value) => {
    if (typeof value === 'string') {
      let sanitizedValue = value.replace(/\t/g, ' ').replace(/\r/g, '')
      sanitizedValue = sanitizedValue.replace(/[^a-zA-Z0-9 ]/g, '')
      return sanitizedValue
    }
    return value
  }

  useEffect(() => {
    console.log("Category state changed to:", category)
  }, [category])

  useEffect(() => {
    if (expiryDate) {
      console.log("useEffect triggered for expiry date:", expiryDate)
      const calculated = calculateCategory(expiryDate)
      console.log("Calculated category in useEffect:", calculated)
      if (calculated) {
        setCategory(calculated)
      }
    }
  }, [expiryDate])

  const calculateCategory = (date) => {  
        if (date) {
          const expiryDateMoment = moment(date, 'YYYY-MM-DD').startOf('month')
        const currentDateMoment = moment(lrDate, 'YYYY-MM-DD').startOf('month') || moment().startOf('month')
          const fourMonthsFromNow = currentDateMoment.clone().add(4, 'months') 
          if (
            expiryDateMoment.isBefore(currentDateMoment) ||
            expiryDateMoment.isSame(currentDateMoment, 'month')
          ) {
            return 'Expiry'
          } else if (expiryDateMoment.isBefore(fourMonthsFromNow)) {
            return 'Near Expiry'
          }
         else {
          return 'Damage'
        }
      }
      return ""
    }

  const calculateCategories = (date) => {
    if (date) {
      const calculated = calculateCategory(date)
      setCategory(calculated)
    } else {
      console.log("No date provided, setting empty category")
      setCategory('')
    }
  }

  const getNextItem = () => {
    const item = scanResultQueue.popItem()
    if (!item) {
      return
    }

    // console.log("Processing item:", item)

    let itemCategory = item['category']
    if (!itemCategory && item['expiryDate']) {
      itemCategory = calculateCategory(item['expiryDate'])
    }

    setCurrentItem(item)
    setSessionId(item['sessionId'] ?? '')
    setType((item['type']) ?? '')
    setPartyCode(item['associateDetails']?.code || '-NA-')
    setPartyName(item['associateDetails']?.name || '-NA-')
    setImageUrl(item['imageUrl'] ?? '')
    setProductName(sanitizeValue(item['productName']) ?? '')
    setProductCode(sanitizeValue(item['itemCode']) ?? '')
    setBatch(sanitizeValue(item['batchNumber']) ?? '')
    setMBatch(sanitizeValue(item['batchNumber']) ?? '')
    setMRP(sanitizeValue(item['mrp']) ?? '')
    setExpiryDate(item['expiryDate'] ?? '')
    setMFGDate(item['mfgDate'] ?? '')
    setQuantities('1')
    setProductId(item['id'] ?? '')
    setTransactionId(item['transactionId'] ?? '')
    setFirebaseKey(item['firebaseKey'])
    setAlgorithmType(item['algo'] ?? '')
    setReceivedPlatform(item['platform'] ?? '')
    setRemark(item['remark'] ?? 'from web app')
    setLrDate(item['lrDate'] ?? '')
    setlrNo(item['lrNo'] ?? '')
    setclaimNo(item['claimNo'] ?? '')
    setclaimDate(item['claimDate'] ?? '')
    setReceivedDate(item['receivedDate'] ?? '')
    setInputParams(item['inputParams'] ?? '')
    setCategory(itemCategory || '')
  }

  const processSelectedItemDirectly = async (item) => {
    const sanitizedProductName = sanitizeValue(item['SKU'] || '')
    const sanitizedBatch = sanitizeValue(item['BATCHNUMBER'] || '')
    const sanitizedMRP = sanitizeValue(item['MRP']?.toString() || '')
    const expiry = item['EXPIRYDATE'] || ''
    const qty = '1'
    const productId = item['_id'] || ''
    const mfg = item['MFG_DATE'] || ''
    const type = (item['type'] || '')
    const remark = item['remark'] || 'from web app'
    const firebaseKey = item['firebaseKey'] || ''
    const category = item['category'] || calculateCategory(expiry)
    const platform = getPlatformFromAlgorithm(item['algo'])

    if (!sanitizedProductName || !sanitizedBatch || !sanitizedMRP || !expiry || !category) {
      toast.warn('Required fields are missing: productName, batch, mrp, expiryDate, or category')
      return false
    }

    const associateInfo = typeof item['associateDetails'] === 'string'
      ? JSON.parse(item['associateDetails'])
      : item['associateDetails'] || {}

    const body = {
      sku: sanitizedProductName,
      productId,
      type,
      quantity: qty,
      expiryDate: expiry ? expiry.split('-').reverse().join('-') : '',
      mfgDate: mfg ? mfg.split('-').reverse().join('-') : '',
      batchnumber: sanitizedBatch,
      mrp: sanitizedMRP,
      transactionId: item['t_id'] || undefined,
      platform,
      verified: true,
      remark,
      category,
      sessionId: item['sessionId'] || '',
      associateId: associateInfo['code'] || '',
      lrDate: item['lrDate'] || '',
      lrNo: item['lrNo'] || '',
      claimNo: item['claimNo'] || '',
      claimDate: item['claimDate'] || '',
      receivedDate: item['receivedDate'] || '',
      imageUrl: item['imgUrl'] || '',
      ITEM_CODE: sanitizeValue(item['ITEM_CODE'] || ''),
      inputParams: item['inputParams'] || '',
    }

    const response = await updateTransaction(body, item['t_id'] || '')

    if (response.status === 'success') {
      toast.success('Updated transaction successfully')
      return true
    } else {
      toast.error(response.error)
      return false
    }
  }

  const deleteFirebaseEntry = async (key) => {
    const database = ref(getDatabase(firebase), sessionStorage['username'] + '/' + key)
    await remove(database)
  }

  const confirmScan = async () => {
    if (!productName || productName === '-NA-') return toast.warn('Please enter correct product name')
    if (!batch || batch === '-NA-') return toast.warn('Please enter correct batch number')
    if (!mrp || mrp === '-NA-') return toast.warn('Please enter correct MRP')
    if (!expiryDate || expiryDate === '-NA-') return toast.warn('Please enter correct expiry date')
    if (!quantities || quantities === '-NA-') return toast.warn('Please enter quantities')
    if (!category || category === '-NA-') return toast.warn('Please select category')

    const platform = getPlatformFromAlgorithm(algorithmType)

    const body = {
      sku: productName,
      productId,
      type,
      quantity: quantities,
      expiryDate: expiryDate.split('-').reverse().join('-'),
      mfgDate: mfgDate.split('-').reverse().join('-'),
      batchnumber: batch,
      mrp,
      transactionId: transactionId === '-NA-' ? undefined : transactionId,
      platform,
      verified: true,
      remark,
      category,
      sessionId,
      associateId: partyCode,
      lrDate,
      lrNo,
      claimNo,
      claimDate,
      receivedDate,
      imageUrl,
      ITEM_CODE: productCode,
      inputParams,
    }

    const response = await updateTransaction(body, transactionId)
    if (response.status === 'success') {
      resetItem()
      toast.success('Updated transaction successfully')
      shouldContinue()
    } else {
      toast.error(response.error)
    }
  }

  const resetItem = () => {
    setSessionId('')
    setType('')
    setPartyCode('')
    setPartyName('')
    setImageUrl('')
    setProductName('')
    setProductCode('')
    setBatch('')
    setMBatch('')
    setMRP('')
    setExpiryDate('')
    setMFGDate('')
    setQuantities('1')
    setProductId('')
    setTransactionId('')
    setFirebaseKey('')
    setCategory('')
    setAlgorithmType('')
    setReceivedPlatform('')
  }

  const shouldContinue = async () => {
    await deleteFirebaseEntry(firebaseKey)
    scanResultQueue.clearProcessingQueue()
    dispatch(increment())

    const count = scanResultQueue.itemCount()
    if (count > 0) {
      getNextItem()
    } else {
      setCurrentItem(null)
    }
  }

  const deleteScan = async () => {
    try {
      if (!transactionId || transactionId === '-NA-' || transactionId.trim() === '') {
        console.warn('No valid transaction ID to delete')
        toast.info('No transaction to delete, just removing from queue')
        shouldContinue()
        return
      }

      await deleteTransaction(transactionId)
      toast.success('Successfully deleted transaction')
      shouldContinue()
    } catch (error) {
      console.error('Error deleting transaction:', error)
      toast.error('Failed to delete transaction: ' + (error.message || 'Unknown error'))
      shouldContinue()
    }
  }

  const [base64Image, setBase64Image] = useState('')

  useEffect(() => {
    const fetchImageAsBase64 = async () => {
      if (imageUrl) {
        try {
          const response = await fetch(imageUrl)

          const blob = await response.blob()
          const reader = new FileReader()
          reader.onloadend = () => {
            setBase64Image(reader.result)
          }
          reader.readAsDataURL(blob)
        } catch (error) {
          console.error('Error fetching or converting image:', error)
        }
      }
    }
    fetchImageAsBase64()
  }, [imageUrl])

  return (
    <div className={classes.container}>
      <div className="card">
        {!currentItem && (
          <div className={classes.overlay}>
            <h2 className={classes.centerTitle}>Waiting for new scan...</h2>
          </div>
        )}
        {/* {showTick && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "end",
              width: "100%",
              height: "100%",

              zIndex: 2000,
              position: "absolute",
            }}
          >
            <IoCheckmarkDoneSharp
              style={{
                fontSize: "60px",
                color: "white",
                background: "green",
                borderRadius: "50%",
                padding: "10",
              }}
            />
          </div>
        )} */}
        <div className="card-body">
          <div className="row">
            <div className="col">
              <div className={classes.imageContainer}>
                <img className={classes.image} src={base64Image} alt="" />
              </div>
            </div>
            <div className="col">
              <div className="row">
                <div className="col">
                  <div className="row">
                    <div className="col">
                      <span className={classes.label}>Type: </span>
                      <span>{type} </span>
                    </div>
                    <div className="col">
                      <span className={classes.label}>Party Code: </span>
                      <span>{partyName}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row" style={{ marginTop: 10 }}>
                <div className="row">
                  <div className="col">
                    <div className="row">
                      <div className="col">
                        <div className="mb-3">
                          <label htmlFor="">Batch Number</label>
                          <BatchNumberFinder
                            defaultValue={batch}
                            onChange={(value) => {
                              setBatch(sanitizeValue(value))
                            }}
                            onSelectProduct={(item) => {
                              setProductId(item['_id'])
                              setBatch(sanitizeValue(item['BATCHNUMBER']))
                              setProductCode(sanitizeValue(item['ITEM_CODE']))
                              setProductName(sanitizeValue(item['SKU']))
                              setMRP(sanitizeValue(item['MRP']))

                              const expiryDates = item['EXPIRYDATE']
                              if (expiryDates && expiryDates.length == 8) {
                                const formattedDate = `${expiryDates.substr(
                                  0,
                                  4
                                )}-${expiryDates.substr(
                                  4,
                                  2
                                )}-${expiryDates.substr(6, 2)}`
                                console.log(`formatted date: ${formattedDate}`)
                                setExpiryDate(formattedDate)
                                // Category will be calculated automatically by useEffect
                              }

                              const mfgDate = item['MFG_DATE']
                              if (mfgDate && mfgDate.length == 8) {
                                const formattedDate = `${mfgDate.substr(
                                  0,
                                  4
                                )}-${mfgDate.substr(4, 2)}-${mfgDate.substr(
                                  6,
                                  2
                                )}`
                                console.log(`formatted mfg date: ${formattedDate}`)
                                setMFGDate(formattedDate)
                              }
                            }}
                          />
                          {/* <input
                            type='text'
                            className='form-control'
                            value={batch}
                            onChange={(e) => {
                              setBatch(e.target.value)
                            }}
                          /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="row">
                      <div className="col">
                        <div className="mb-3">
                          <label htmlFor="">Product Name</label>
                          <input
                            type="text"
                            className="form-control"
                            value={productName}
                            onChange={(e) => {
                              setProductName(sanitizeValue(e.target.value))
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="mb-3">
                      <label htmlFor="">Product Code</label>
                      <input
                        type="text"
                        className="form-control"
                        value={productCode}
                        onChange={(e) => {
                          setProductCode(sanitizeValue(e.target.value))
                        }}
                      />
                    </div>
                  </div>
                  <div className="col">
                    <div className="mb-3">
                      <label htmlFor="">Category</label>
                      <select
                        className="form-control"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                      >
                        <option value="">Select Category</option>
                        <option value="Expiry">Expiry</option>
                        <option value="Near Expiry">Near Expiry</option>
                        <option value="Damage">Damage</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="mb-3">
                      <label htmlFor="">Expiry Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={expiryDate}
                        onChange={(e) => {
                          setExpiryDate(e.target.value)
                          calculateCategories(e.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className="col">
                    <div className="mb-3">
                      <label htmlFor="">MFG Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={mfgDate}
                        onChange={(e) => {
                          setMFGDate(e.target.value)
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="mb-3">
                      <label htmlFor="">MRP</label>
                      <input
                        type="number"
                        className="form-control"
                        value={mrp}
                        onChange={(e) => {
                          setMRP(e.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className="col">
                    <div className="mb-3">
                      <label htmlFor="">Quantities</label>
                      <input
                        value={quantities}
                        type="number"
                        className="form-control"
                        onChange={(e) => {
                          setQuantities(sanitizeValue(e.target.value))
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="card-footer"
          style={{
          padding: 10,
          display: 'flex',
          justifyContent: 'space-between',
          }}
        >
          <div>
            <button onClick={confirmScan} className="btn btn-success">
              Confirm
            </button>
            <button
              onClick={deleteScan}
              className="btn btn-danger"
              style={{ marginLeft: 10 }}
            >
              Discard
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ScanResult

let isPopupOpen = false

function showSelectScanPopup(scanOptions) {
  return new Promise((resolve) => {
    if (isPopupOpen) return // prevent multiple popups
    isPopupOpen = true

    const popupDiv = document.createElement('div')
    document.body.appendChild(popupDiv)

    const handleClose = () => {
      ReactDOM.unmountComponentAtNode(popupDiv)
      popupDiv.remove()
      isPopupOpen = false // reset
    }

    const handleSelect = (item) => {
      handleClose()
      resolve(item)
    }

    const Popup = () => {
      const [selectedIndex, setSelectedIndex] = React.useState(0)

      React.useEffect(() => {
        const handleKeyDown = (e) => {
          if (e.key === 'ArrowDown') {
            setSelectedIndex((prev) => (prev + 1) % scanOptions.length)
            e.preventDefault()
          } else if (e.key === 'ArrowUp') {
            setSelectedIndex(
              (prev) => (prev - 1 + scanOptions.length) % scanOptions.length
            )
            e.preventDefault()
          } else if (e.key === 'Enter') {
            handleSelect(scanOptions[selectedIndex])
            e.preventDefault()
          } else if (e.key === 'Escape') {
            handleClose()
            resolve(null)
            e.preventDefault()
          } else if (/^[1-9]$/.test(e.key)) {
            const idx = parseInt(e.key, 10) - 1
            if (idx < scanOptions.length) {
              handleSelect(scanOptions[idx])
            }
          }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
      }, [selectedIndex])

      return (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: 20,
              borderRadius: 10,
              maxWidth: '90%',
              width: 800,
              maxHeight: '80vh',
              overflowY: 'auto',
            }}
          >
            <h4>Select Scanned Result</h4>
            <table className="table table-bordered table-hover mt-3">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Item Code</th>
                  <th>Product Name</th>
                  <th>Batch No.</th>
                  <th>Expiry</th>
                  <th>MFG</th>
                  <th>MRP</th>
                </tr>
              </thead>
              <tbody>
                {scanOptions.map((item, idx) => (
                  <tr
                    key={idx}
                    style={{
                      cursor: 'pointer',
                      backgroundColor: selectedIndex === idx ? '#d1ecf1' : '',
                    }}
                    onClick={() => handleSelect(item)}
                  >
                    <td>{idx + 1}</td>
                    <td>{item?.ITEM_CODE || ''}</td>
                    <td>{item?.SKU || item?.productName || ''}</td>
                    <td>{item?.BATCHNUMBER || ''}</td>
                    <td>{item?.EXPIRYDATE || ''}</td>
                    <td>{item?.MFG_DATE || ''}</td>
                    <td>₹{item?.MRP || ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="text-muted" style={{ marginTop: 10, fontSize: 12 }}>
              ↑ ↓ to navigate, Enter to select, 1–9 to choose row, Esc to cancel
            </p>
          </div>
        </div>
      )
    }

    ReactDOM.render(<Popup />, popupDiv)
  })
}
